module.exports = __webpack_public_path__ + "media/images/icons/icons_small/23_car-77c85c1480957e8b01af1a88be4b2178.png";